
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyIJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginatonInput"}},"defaultValue":{"kind":"ObjectValue","fields":[]},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JobsFiltersInput"}},"defaultValue":{"kind":"ObjectValue","fields":[]},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customFilteredJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jobCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customFilteredJobs"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"regionID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remoteStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryID"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originalLocation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"experienceLevel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyATSDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atsType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"atsUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"atsTracking"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isEasyApply"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"geoLocations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"State"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"City"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Coordinates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"GeoName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isHybrid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isEasyApply"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bodySummary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"body"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":843}};
    doc.loc.source = {"body":"query GetCompanyIJobs($pagination: PaginatonInput = {}, $filters: JobsFiltersInput = {}) {\n customFilteredJobs(pagination: $pagination, filters: $filters ) {\n        jobCount\n        customFilteredJobs {\n            id\n            title\n            location\n            regionID\n            remoteStatus\n            categoryID\n            url\n            originalLocation\n            experienceLevel\n            company {\n              id\n              companyATSDetails {\n                atsType\n                atsUrl\n                atsTracking\n              }\n              isEasyApply\n            }\n            geoLocations {\n                State\n                City\n                Coordinates\n                GeoName\n            }\n            isHybrid\n            isEasyApply\n            bodySummary\n            body\n        }\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetCompanyIJobs"] = oneQuery(doc, "GetCompanyIJobs");
        
